











































import slugify from '@/lib/slugify'

export default {
  data: function() {
    return {
      client: {
        slug: '',
        name: ''
      }
    }
  },
  watch: {
    'client.name': function() {
      this.client.slug = slugify(this.client.name)
    }
  },
  methods: {
    saveClient() {
      this.$api.clientAdmin
        .CreateClient(this.client)
        .then(() => this.$router.push({ name: 'settings-clients-list' }))
    }
  }
}
